// Round according to the world standard which is to round up when 0.5 or up, and round down when less then 0.5.
// Rounding to [roundingNumber] decimals.
export const roundedNum = (num, precision, roundingNumber = 10) => {
    let tempNumber = num;
    for (let i = roundingNumber; i > precision; i--) {
        let unit = Number(`1E${i - 1}`);
        tempNumber = Math.round(Number((tempNumber * unit).toFixed(2))) / unit;
    }
    return tempNumber;
};
//# sourceMappingURL=index.js.map